import PropTypes, { string, array } from 'prop-types';
import React, { useEffect, useState } from 'react';
import DfpAd from '../../atoms/dfp-ad';

import './ad-with-placeholder.m.css';
import get from 'lodash/get';
import { connect } from 'react-redux';

const AdWithPlaceholder = ({
  adtype,
  width = '100%',
  height,
  adUnit,
  sizes,
  isSubscriber,
  pageType,
  customClass = '',
  ...props
}) => {
  const [showAd, setShowAd] = useState(true);
  useEffect(() => {
    if (window.location.href.includes('/bq-brand-studio/')) {
      setShowAd(false);
    }
  }, []);

  const adLabelClass = adtype === 'BeepsAd' ? 'advertisement-beeps' : 'advertisement';
  const adContainerClass =
    adtype === 'LiveBlogAfterThreeCardsMobile' ||
      adtype === 'AfterArticleMobilePara2' ||
      adtype === 'BeepsAd'
      ? 'ad-container-live-blog-mobile'
      : 'ad-container';

  if (!showAd || isSubscriber) return null;

  return (
    <div styleName={`place-holder-wrapper ${customClass}`} style={{ width }}>
      <span styleName={adLabelClass}>ADVERTISEMENT</span>
      <div
        styleName={adContainerClass}
        style={{
          height: height ?? 'auto',
          minHeight: height ?? 'auto',
          width: width ?? 'auto',
        }}
      >
        <DfpAd adUnit={adUnit} sizes={sizes} {...props} />
      </div>
    </div>
  );
};

AdWithPlaceholder.propTypes = {
  adtype: string,
  width: string,
  height: string,
  isSubscriber: PropTypes.bool,
  adUnit: string,
  sizes: array,
};

const mapStateToProps = (state) => ({
  isSubscriber: get(state, ['userData', 'isSubscriber'], false),
});

export default connect(mapStateToProps)(AdWithPlaceholder);
